<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 17 17"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M2.523 15.545a.757.757 0 0 1-.756-.756V5.533h13.671v9.256c0 .417-.34.756-.756.756zM14.682 1.873c.417 0 .756.34.756.756v1.997H1.767V2.629c0-.417.339-.756.756-.756zm0-.907H2.522C1.606.966.86 1.712.86 2.629v12.16c0 .917.746 1.663 1.664 1.663h12.159c.917 0 1.663-.746 1.663-1.663V2.629c0-.917-.746-1.663-1.663-1.663z"
        />
      </g>
      <g>
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="20"
          stroke-width="0.2"
          d="M2.523 15.545a.757.757 0 0 1-.756-.756V5.533h13.671v9.256c0 .417-.34.756-.756.756zM14.682 1.873c.417 0 .756.34.756.756v1.997H1.767V2.629c0-.417.339-.756.756-.756zm0-.907H2.522C1.606.966.86 1.712.86 2.629v12.16c0 .917.746 1.663 1.664 1.663h12.159c.917 0 1.663-.746 1.663-1.663V2.629c0-.917-.746-1.663-1.663-1.663z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M14.5 3.265a.454.454 0 1 1-.907 0 .454.454 0 0 1 .907 0z"
        />
      </g>
      <g>
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="20"
          stroke-width="0.2"
          d="M14.5 3.265a.454.454 0 1 1-.907 0 .454.454 0 0 1 .907 0z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M12.686 3.265a.454.454 0 1 1-.908 0 .454.454 0 0 1 .908 0z"
        />
      </g>
      <g>
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="20"
          stroke-width="0.2"
          d="M12.686 3.265a.454.454 0 1 1-.908 0 .454.454 0 0 1 .908 0z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M10.87 3.265a.454.454 0 1 1-.906 0 .454.454 0 0 1 .907 0z"
        />
      </g>
      <g>
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="20"
          stroke-width="0.2"
          d="M10.87 3.265a.454.454 0 1 1-.906 0 .454.454 0 0 1 .907 0z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M13.593 9.163H3.612V7.348h9.981zm.454-2.723H3.157a.454.454 0 0 0-.453.454v2.722c0 .251.203.454.454.454h10.889c.25 0 .453-.203.453-.454V6.894a.454.454 0 0 0-.453-.454z"
        />
      </g>
      <g>
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="20"
          stroke-width="0.2"
          d="M13.593 9.163H3.612V7.348h9.981zm.454-2.723H3.157a.454.454 0 0 0-.453.454v2.722c0 .251.203.454.454.454h10.889c.25 0 .453-.203.453-.454V6.894a.454.454 0 0 0-.453-.454z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M7.241 13.7h-3.63v-1.815h3.63zm.454-2.723H3.158a.454.454 0 0 0-.454.454v2.722c0 .251.203.454.454.454h4.537c.25 0 .454-.203.454-.454v-2.722a.454.454 0 0 0-.454-.454z"
        />
      </g>
      <g>
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="20"
          stroke-width="0.2"
          d="M7.241 13.7h-3.63v-1.815h3.63zm.454-2.723H3.158a.454.454 0 0 0-.454.454v2.722c0 .251.203.454.454.454h4.537c.25 0 .454-.203.454-.454v-2.722a.454.454 0 0 0-.454-.454z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M13.593 13.7h-3.63v-1.815h3.63zm.454-2.723H9.51a.454.454 0 0 0-.454.454v2.722c0 .251.203.454.454.454h4.537c.25 0 .453-.203.453-.454v-2.722a.454.454 0 0 0-.453-.454z"
        />
      </g>
      <g>
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="20"
          stroke-width="0.2"
          d="M13.593 13.7h-3.63v-1.815h3.63zm.454-2.723H9.51a.454.454 0 0 0-.454.454v2.722c0 .251.203.454.454.454h4.537c.25 0 .453-.203.453-.454v-2.722a.454.454 0 0 0-.453-.454z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#B2A8C1',
    },
    size: {
      type: Number,
      default: 17,
    },
  },
};
</script>
